// extracted by mini-css-extract-plugin
module.exports = {"star":"_5RMS0_","icon":"_3Ze4PR","shine-lines":"rpenb3"};